export default "__VITE_ASSET__CCOIhg80__"